export default "__VITE_PUBLIC_ASSET__bbdd1e76__"